import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'

import { Roles } from '../../config'
import Loading from '../Loading'
import ProjectSettingsGeneral from './ProjectSettingsGeneral'
import ProjectSettingsUsers from './ProjectSettingsUsers'
import ProjectSettingsQuestions from './ProjectSettingsQuestions'
import ProjectSettingsIntegrations from './ProjectSettingsIntegrations'

import { Tabs, Button, Icon } from 'antd'
const TabPane = Tabs.TabPane

class ProjectSettings extends Component {
  componentDidMount = () => {
    const { history } = this.props

    if (!history.location.hash) {
      history.push({ hash: 'general' })
    }
  }

  onTabsChange = tabKey => {
    const { history } = this.props

    history.push({ hash: tabKey })
  }

  render () {
    const { match: { params }, projects, user } = this.props

    if (!user) return <p>You need to be logged in to see the settings</p>
    // redux - wait for projects and user's projectroles
    if (!projects || !user.projectsRoles) return <Loading />

    const myProjectRole = user.projectsRoles[params.projectId]
    if (myProjectRole > Roles.PROJECT.MANAGER) return <p>You don't have access to this page</p>

    const currentProject = projects[params.projectId]

    // get just 'tab' info from the location hash (e.g. '#integrations?code=...' => 'integrations')
    let urlHashTab = 'general'
    if (window.location.hash) {
      urlHashTab = window.location.hash.split('#')[1].split('?')[0]
    }

    return (
      <div>

        <Link to={`/project/${params.projectId}`}>
          <Button icon='left' style={{ position: 'absolute', right: 40, zIndex: 1 }}>
            Back to Project
          </Button>
        </Link>

        <Tabs type='card' defaultActiveKey={urlHashTab} onChange={this.onTabsChange}>

          <TabPane tab={<span><Icon type='setting' />General</span>} key='general'>
            <ProjectSettingsGeneral project={currentProject} />
          </TabPane>

          <TabPane tab={<span><Icon type='usergroup-add' />Users</span>} key='users'>
            <ProjectSettingsUsers project={currentProject} />
          </TabPane>

          <TabPane tab={<span><Icon type='question-circle' />Questions</span>} key='questions'>
            <ProjectSettingsQuestions project={currentProject} />
          </TabPane>

          <TabPane tab={<span><Icon type='sync' />Integrations</span>} key='integrations'>
            <ProjectSettingsIntegrations project={currentProject} />
          </TabPane>

        </Tabs>

      </div>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  projects: state.projects,
  user: state.user
})

export default connect(mapStateToProps)(withRouter(ProjectSettings))



// WEBPACK FOOTER //
// ./src/components/ProjectSettings/index.js